import styled from "styled-components";

export const FormContainer = styled.div`
  max-width: 1100px;
  padding: 4em 0;

  background-color: #F2F2F2;
  margin: 0 auto;
`;

export const Title = styled.h2`
  font-size: 2.5em;
  font-weight: bold;
`;

export const Subtitle = styled.p`
  color: gray;
`;

export const Label = styled.label`
  display: block;
  margin: 10px 0 5px;
  font-weight: bold;
  text-transform: uppercase;
`;

export const Input = styled.input`
  width: 100%;
  padding: 15px 20px;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  background-color: #E7E7E7;
`;

export const FileInput = styled.button`
  display: flex;
  align-items: center;
  align-self: flex-end;
  background-color: none;
  color: rgba(234, 11, 42, 1);
  border: 1px solid rgba(234, 11, 42, 1);
  padding: 10px 30px;
  border-radius: 30px;
  font-size: 0.9em;
  cursor: pointer;

  p{
    margin-left: 5px;
  }

  &:hover {
    background-color: rgba(234, 11, 42, 1);
    color: white;
  }
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  margin-top: 10px;
  font-size: 14px;
  margin-bottom: 1.5em;
`;

export const SubmitButton = styled.button`
  align-self: flex-end;
  background-color: rgba(40, 44, 52, 1);
  color: rgb(255, 255, 255);
  border: 1px solid rgba(40, 44, 52, 1);
  padding: 10px 30px;
  border-radius: 30px;
  font-size: 0.9em;
  cursor: pointer;

  &:hover {
    background-color: rgba(234, 11, 42, 1);
    border: 1px solid rgba(234, 11, 42, 1);
    color: white;
  }
`;

export const NameAndPhoneContainer = styled.div`
  display: flex;
  margin-top: 1em;
  justify-content: space-between;
`
export const InputContainer = styled.div`
  width: 40%;
  margin-bottom: 1.5em;
`

export const CVContainer = styled.div`
  margin-top: 1.5em;
`

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`